/**
 * @function 诸葛埋点
 * @Date 2019-07-09
 * @tips 埋点使用说明
 * - [usercode] 操作人用户识别码
 * - [handleTime] 操作执行时间
 *   - [switchTabs] 切换Tab页。 值 { tab： 待办/已办/发起/通知 }
 *   - [search] 用户执行搜索。 值 { tab: 所在页签, keyword: 关键字 }
 *   - [filter] 用户执行筛选。 值 { tab: 所在页签, state：筛选状态，type：筛选类型 }
 */
import { env } from '@/api/env'
const zhuge = {
  init() {
    // let env = window.location.href.indexOf('moapproval.longfor.com') > -1 ? 'production' : 'test'
    // let sdkUrl = `https://datain${env === 'production' ? '' : 'test'}.longfor.com/zhuge.js?v=`
    // let appKey = env === 'production' ? `d5b80635fdcc485181a2f52889f7ea44` : `dd2f50fa972d47ffa1bd04c83633abf9`

    let sdkUrl =
      (env === 'nprd'||env === 'wnprd')
        ? 'https://datain.longfor.com/zhuge.js?v='
        : 'https://dataintest.longfor.com/zhuge.js?v='
    let appKey =
    (env === 'nprd'||env === 'wnprd')
        ? 'd5b80635fdcc485181a2f52889f7ea44'
        : 'dd2f50fa972d47ffa1bd04c83633abf9'
    window.zhuge = window.zhuge || []
    window.zhuge.methods = '_init identify track getDid getSid getKey setSuperProperty setUserProperties setWxProperties setPlatform'.split(' ')
    window.zhuge.factory = function (b) {
      return function () {
        var a = Array.prototype.slice.call(arguments)
        a.unshift(b)
        window.zhuge.push(a)
        return window.zhuge
      }
    }
    for (var i = 0; i < window.zhuge.methods.length; i++) {
      var key = window.zhuge.methods[i]
      window.zhuge[key] = window.zhuge.factory(key)
    }
    window.zhuge.load = function (b, x) {
      if (!document.getElementById('zhuge-js')) {
        var a = document.createElement('script')
        var verDate = new Date()
        var verStr = verDate.getFullYear().toString() + verDate.getMonth().toString() + verDate.getDate().toString()

        a.type = 'text/javascript'
        a.id = 'zhuge-js'
        a.async = !0
        a.src = sdkUrl + verStr
        a.onerror = function () {
          window.zhuge.identify = window.zhuge.track = function (ename, props, callback) {
            if (callback && Object.prototype.toString.call(callback) === '[object Function]') {
              callback()
            } else if (Object.prototype.toString.call(props) === '[object Function]') {
              props()
            }
          }
        }
        var c = document.getElementsByTagName('script')[0]
        c.parentNode.insertBefore(a, c)
        window.zhuge._init(b, x)
      }
    }
    window.zhuge.load(appKey, {
      // 全局的事件属性(选填)
      superProperty: { '应用名称': '待办事宜' },
      autoTrack: false, // 启用全埋点采集（选填，默认false）
      // debug: true, // 实时调试
      singlePage: false // 是否是单页面应用（SPA），启用autoTrack后生效（选填，默认false）
    })
  }
}

export { zhuge }
